/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
export const WfnActionMenu = /*@__PURE__*/ createReactComponent('wfn-action-menu');
export const WfnAddress = /*@__PURE__*/ createReactComponent('wfn-address');
export const WfnAutocompleteAddress = /*@__PURE__*/ createReactComponent('wfn-autocomplete-address');
export const WfnAvatar = /*@__PURE__*/ createReactComponent('wfn-avatar');
export const WfnBadge = /*@__PURE__*/ createReactComponent('wfn-badge');
export const WfnBbqPlateLoader = /*@__PURE__*/ createReactComponent('wfn-bbq-plate-loader');
export const WfnBox = /*@__PURE__*/ createReactComponent('wfn-box');
export const WfnBusinessCardModal = /*@__PURE__*/ createReactComponent('wfn-business-card-modal');
export const WfnCheckboxTree = /*@__PURE__*/ createReactComponent('wfn-checkbox-tree');
export const WfnCountry = /*@__PURE__*/ createReactComponent('wfn-country');
export const WfnCurrency = /*@__PURE__*/ createReactComponent('wfn-currency');
export const WfnCurrencyBox = /*@__PURE__*/ createReactComponent('wfn-currency-box');
export const WfnDate = /*@__PURE__*/ createReactComponent('wfn-date');
export const WfnDatePicker = /*@__PURE__*/ createReactComponent('wfn-date-picker');
export const WfnDropdownList = /*@__PURE__*/ createReactComponent('wfn-dropdown-list');
export const WfnEmployeeIdBar = /*@__PURE__*/ createReactComponent('wfn-employee-id-bar');
export const WfnExpandableBox = /*@__PURE__*/ createReactComponent('wfn-expandable-box');
export const WfnFileUploader = /*@__PURE__*/ createReactComponent('wfn-file-uploader');
export const WfnFocusPane = /*@__PURE__*/ createReactComponent('wfn-focus-pane');
export const WfnFocusPaneClone = /*@__PURE__*/ createReactComponent('wfn-focus-pane-clone');
export const WfnForm = /*@__PURE__*/ createReactComponent('wfn-form');
export const WfnFroalaEditor = /*@__PURE__*/ createReactComponent('wfn-froala-editor');
export const WfnFullCalendar = /*@__PURE__*/ createReactComponent('wfn-full-calendar');
export const WfnGrid = /*@__PURE__*/ createReactComponent('wfn-grid');
export const WfnHomeHero = /*@__PURE__*/ createReactComponent('wfn-home-hero');
export const WfnHomePageLayout = /*@__PURE__*/ createReactComponent('wfn-home-page-layout');
export const WfnInfiniteList = /*@__PURE__*/ createReactComponent('wfn-infinite-list');
export const WfnInput = /*@__PURE__*/ createReactComponent('wfn-input');
export const WfnIterator = /*@__PURE__*/ createReactComponent('wfn-iterator');
export const WfnMap = /*@__PURE__*/ createReactComponent('wfn-map');
export const WfnMfeLoader = /*@__PURE__*/ createReactComponent('wfn-mfe-loader');
export const WfnMultiSelect = /*@__PURE__*/ createReactComponent('wfn-multi-select');
export const WfnNewsFeed = /*@__PURE__*/ createReactComponent('wfn-news-feed');
export const WfnNewsFeedItem = /*@__PURE__*/ createReactComponent('wfn-news-feed-item');
export const WfnNumber = /*@__PURE__*/ createReactComponent('wfn-number');
export const WfnNumberBox = /*@__PURE__*/ createReactComponent('wfn-number-box');
export const WfnObfuscation = /*@__PURE__*/ createReactComponent('wfn-obfuscation');
export const WfnPageHeaderButton = /*@__PURE__*/ createReactComponent('wfn-page-header-button');
export const WfnPercentInput = /*@__PURE__*/ createReactComponent('wfn-percent-input');
export const WfnPhoneNumberInput = /*@__PURE__*/ createReactComponent('wfn-phone-number-input');
export const WfnQuickStat = /*@__PURE__*/ createReactComponent('wfn-quick-stat');
export const WfnRadioButton = /*@__PURE__*/ createReactComponent('wfn-radio-button');
export const WfnRadioGroup = /*@__PURE__*/ createReactComponent('wfn-radio-group');
export const WfnRightRailLayout = /*@__PURE__*/ createReactComponent('wfn-right-rail-layout');
export const WfnShellAppBarSearch = /*@__PURE__*/ createReactComponent('wfn-shell-app-bar-search');
export const WfnShellMegaMenu = /*@__PURE__*/ createReactComponent('wfn-shell-mega-menu');
export const WfnShellTopNav = /*@__PURE__*/ createReactComponent('wfn-shell-top-nav');
export const WfnSimpleHelpIcon = /*@__PURE__*/ createReactComponent('wfn-simple-help-icon');
export const WfnSseListener = /*@__PURE__*/ createReactComponent('wfn-sse-listener');
export const WfnTaxId = /*@__PURE__*/ createReactComponent('wfn-tax-id');
export const WfnTaxIdInput = /*@__PURE__*/ createReactComponent('wfn-tax-id-input');
export const WfnTaxIdSelection = /*@__PURE__*/ createReactComponent('wfn-tax-id-selection');
export const WfnText = /*@__PURE__*/ createReactComponent('wfn-text');
export const WfnTextarea = /*@__PURE__*/ createReactComponent('wfn-textarea');
export const WfnTimelineCard = /*@__PURE__*/ createReactComponent('wfn-timeline-card');
export const WfnTimelineContainer = /*@__PURE__*/ createReactComponent('wfn-timeline-container');
export const WfnTracker = /*@__PURE__*/ createReactComponent('wfn-tracker');
export const WfnVerticalWizard = /*@__PURE__*/ createReactComponent('wfn-vertical-wizard');
//# sourceMappingURL=components.js.map